// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_g6JKs clearfix","tit01":"index_tit01_BXJf3","t_name":"index_t_name_WbOKp","s01":"index_s01_209Om","s02":"index_s02_Ds4rR"};